import React from 'react';
import './NmpVideo.scss';
import {
  buildWatchUrl,
  extractNmpSrc,
  isTruthy,
  nmpIframeAllow,
} from './nmpWatchUrl';

export default function NmpVideo({
  nmpAssetId,
  nmpAutoplay,
  nmpHideControls,
  nmpMuted,
  nmpLoop,
  nmpAllowFullscreen,
  nmpTheme,
  nmpWidth,
  nmpHeight,
  nmpEmbed,
}) {
  const src = nmpAssetId
    ? buildWatchUrl({
        nmpAssetId,
        nmpAutoplay,
        nmpHideControls,
        nmpMuted,
        nmpLoop,
        nmpTheme,
      })
    : extractNmpSrc(nmpEmbed);

  if (!src) return null;

  const width = Number(nmpWidth) > 0 ? Number(nmpWidth) : 800;
  const height = Number(nmpHeight) > 0 ? Number(nmpHeight) : 450;
  const allow = nmpIframeAllow(src, nmpAllowFullscreen);

  return (
    <div className="nmp-video">
      <iframe
        src={src}
        width={width}
        height={height}
        {...(allow ? { allow } : {})}
        {...(isTruthy(nmpAllowFullscreen) ? { allowFullScreen: true } : {})}
      />
    </div>
  );
}
